import React, { useEffect, useState } from 'react';
import { GlobalBanner } from './GlobalBanner';

const STORAGE_KEY = 'riac_denied_underage';

export const markUnderageDenied = (): void => {
  try {sessionStorage.setItem(STORAGE_KEY, '1');} catch {/* ignore */}
};

export const UnderageDeniedBanner = () => {
  const [denied, setDenied] = useState(false);

  useEffect(() => {
    try {
      if(sessionStorage.getItem(STORAGE_KEY)) {
        sessionStorage.removeItem(STORAGE_KEY);
        setDenied(true);
      }
    } catch {/* ignore */}
  }, []);

  if(!denied) return null;

  return (
    <GlobalBanner
      color='error'
      onDismiss={() => setDenied(false)}
    >
      You must be at least 18 years old to register or bid with Rock Island Auction Company. You have been signed out.
    </GlobalBanner>
  );
};
